import { css } from "@emotion/react";
import { grayScale } from "@teamsparta/design-system";

export const discWithIndent = (size: number, color: string) => css`
  position: relative;
  margin-left: 19px;
  &:before {
    position: absolute;
    left: -10px;
    top: 8px;
    content: "";
    width: ${size}px;
    height: ${size}px;
    border-radius: 4px;
    background-color: ${color};
  }
`;

export const indentDisc = discWithIndent(3, grayScale.gray80);
